import { LARGE, MEDIUM } from "../../../../constants/breakpoints/breakpoints.js";
import "react/jsx-runtime";
import { typography } from "../../../../themes/typography/typography.js";
import "color-alpha";
import "@mui/material";
import { ExternalTheme } from "../../../../themes/external-theme/external-theme.js";
import "../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../themes/shadows/shadows.js";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../../constants/colors/palette.js";
import "../../../../themes/alert/alert.js";
import "../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../themes/button/button.js";
import "../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../themes/button/styles/external/filled.styles.js";
import "../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../themes/checkbox/checkbox.js";
import "../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../themes/form-control-label/form-control-label.js";
import "../../../../themes/radio/radio.js";
import "../../../../themes/switch/switch.js";
const DirectionWrapperStyles = {
  pt: 13,
  pb: 9,
  [ExternalTheme.breakpoints.down(LARGE)]: {
    pt: 10,
    pb: 10
  },
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    pt: 6,
    pb: 6
  }
};
const DirectionComponentStyles = {
  display: "flex",
  justifyContent: "space-around",
  gap: 3,
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    flexDirection: "column",
    alignItems: "flex-start"
  }
};
const DirectionItemStyles = {
  backgroundColor: "primary.50",
  flex: 1,
  borderRadius: 2,
  padding: 4,
  textAlign: "left"
};
const DirectionCardWrapperStyles = {
  maxWidth: "495px",
  [ExternalTheme.breakpoints.down(LARGE)]: {
    maxWidth: "360px"
  }
};
const DirectionHeaderStyles = {
  ...typography["DM Serif H3"],
  color: "grey.800",
  pt: 3,
  [ExternalTheme.breakpoints.down(LARGE)]: {
    pt: 4
  }
};
const DirectionDescriptionStyles = {
  ...typography["Lato Body 1"],
  color: "grey.800",
  ["word-break"]: "break-word",
  pt: 3,
  [ExternalTheme.breakpoints.down(LARGE)]: {
    pt: 2
  }
};
const DirectionImageWrapper = {
  height: 92,
  div: {
    height: "100%",
    width: "fit-content",
    paddingTop: 2,
    borderTop: "3px solid",
    borderColor: "primary.800"
  }
};
const DirectionTransportWrapperStyles = {
  display: "flex",
  flexWrap: "wrap",
  mt: 3,
  columnGap: 2,
  rowGap: 3,
  [ExternalTheme.breakpoints.down(LARGE)]: {
    rowGap: 4
  }
};
const TransportRouteStyles = {
  display: "flex",
  flexGrow: 1
};
const TransportRouteTextStyles = {
  ...typography["Lato Emphasized 1"],
  flex: "1",
  ml: 2,
  color: ExternalTheme.palette.text.primary
};
export {
  DirectionCardWrapperStyles,
  DirectionComponentStyles,
  DirectionDescriptionStyles,
  DirectionHeaderStyles,
  DirectionImageWrapper,
  DirectionItemStyles,
  DirectionTransportWrapperStyles,
  DirectionWrapperStyles,
  TransportRouteStyles,
  TransportRouteTextStyles
};
